import { publicUrlFor } from "../../../../globals/constants";
import { serviceData } from "../../../../globals/serviceDetail";
import { NavLink } from "react-router-dom";

function SectionWhyChooseUs1() {
    // Convert serviceData object to array and take first 6 services
    const services = Object.entries(serviceData).slice(0, 8);

    // Icon mapping for different services
    const iconMapping = {
        businessIntelligence: "flaticon-chart",
        creditScore: "flaticon-data",
        dataStrategyConsultation: "flaticon-parking",
        dataMiningProcessing: "flaticon-programmer",
        predictiveAnalysis: "flaticon-positive-review",
        sentimentAnalysis: "flaticon-profit",
        dataVisualizationLiveDashboards: "flaticon-chart",
        webAnalytics: "flaticon-data",
        buildingRecommendedSystems: "flaticon-programmer",
        softwareDevelopment: "flaticon-positive-review",
    };

    return (
        <>
            <div className="section-full p-t110 p-b80 sx-why-chooseus-outer sx-bg-light bg-cover" style={{ backgroundImage: `url(${publicUrlFor("images/background/DFC.jpg")})` }}>
                <div className="container">
                    {/* TITLE START */}
                    <div className="section-head center">
                        <div className="sx-head-s-title text-white">Why Choose Us</div>
                        <div className="sx-head-l-title">
                            <h2 className="sx-title text-white">Our Work Services</h2>
                        </div>
                    </div>
                    {/* TITLE END */}
                    <div className="section-content">
                        <div className="sx-icon-bx-wrap">
                            <div className="row">
                                {services.map(([serviceKey, service], index) => (
                                    <div key={serviceKey} className="col-lg-3 col-md-6 wow fadeInDown" data-wow-duration="1000ms">
                                        <div className="sx-icon-bx-1">
                                            <div className="sx-icon-box-wraper">
                                                <div className="sx-icon-bx-icon">
                                                    <span className="sx-text-primary">
                                                        <i className={iconMapping[serviceKey] || "flaticon-data"} />
                                                    </span>
                                                </div>
                                                <div className="icon-content">
                                                    <NavLink to={`/services/detail/${serviceKey}`}>
                                                        <h6 className="sx-tilte">{service.title}</h6>
                                                    </NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionWhyChooseUs1;